import React, { useEffect } from "react";
import funnel from "../../styles/Funnel.module.css";
import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import FormHelperText from "@mui/material/FormHelperText";
import TextField from "@mui/material/TextField";

let CustomSelect = styled(Select)(() => ({
  "&.MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "var(--primary-color)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-color)",
    },
  },
}));

const CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "var(--primary-color)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-color)",
    },
  },
});

const data = [
  { value: "act", label: "ACT" },
  { value: "nsw", label: "NSW" },
  { value: "wa", label: "WA" },
  { value: "vic", label: "VIC" },
  { value: "nt", label: "NT" },
  { value: "qld", label: "QLD" },
  { value: "sa", label: "SA" },
  { value: "tas", label: "TAS" },
];

function State({ formData, setFormData, errors, setErrors }) {
  const [state, setState] = React.useState("");

  useEffect(() => {
    document.title = "Select your state";
  }, []);

  const handleChange = (event) => {
    setFormData({ ...formData, state: event.target.value });
    setState(event.target.value);
    setErrors(false);
  };

  let helperText;
  if (errors == true) {
    CustomSelect = styled(Select)(() => ({
      "&.MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "red",
        },
        "&:hover fieldset": {
          borderColor: "red",
        },
        "&.Mui-focused fieldset": {
          borderColor: "red",
        },
      },
    }));
    helperText = "Please select a state!";
  } else {
    CustomSelect = styled(Select)(() => ({
      "&.MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "var(--primary-color)",
        },
        "&:hover fieldset": {
          borderColor: "var(--primary-color)",
        },
        "&.Mui-focused fieldset": {
          borderColor: "var(--primary-color)",
        },
      },
    }));
    helperText = "";
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <div className={funnel.boxQn}>
        <h2 className={funnel.h2Text}>Select your state and more</h2>
        <FormControl fullWidth>
          <InputLabel
            id="demo-simple-select-label"
            sx={{ "&.Mui-focused": { color: "var(--primary-color)" } }}
          >
            State
          </InputLabel>
          <CustomSelect
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={state}
            label="State"
            onChange={handleChange}
          >
            {data.map((data) => (
              <MenuItem value={data.value}>{data.label}</MenuItem>
            ))}
          </CustomSelect>
          <FormHelperText sx={{ color: "red" }}>{helperText}</FormHelperText>
        </FormControl>
      </div>
    </Box>
  );
}

export default State;
